import { RouteRecordRaw } from "vue-router";
import NoteUploadPage from '@/views/Aio/NoteUploadPage.vue'
import TaskDot from "@/views/Aio/TaskDot.vue"
import TaskDotHalfScreen from '@/views/Aio/TaskDotHalfScreen.vue'

const aioRoutes: Array<RouteRecordRaw> = [
  {
    path: "/sku-task", // sku详情
    name: "SkuTask",
    component: () => import("../views/Aio/SkuTaskDetail.vue"),
    meta: {
      title: "",
      keepAlive: true,
      showActionBar: false,
    },
  },
  {
    path: "/card-detail", // 卡牌/知识点详情
    name: "CardDetail",
    component: () => import("../views/Aio/CardDetail.vue"),
    meta: {
      title: "",
      showActionBar: false,
    },
  },
  {
    path: "/task-paper", // 任务试卷
    name: "TaskPaper",
    component: () => import("../views/Aio/TaskPaper.vue"),
    meta: {
      title: "在线答题",
      showActionBar: false,
    },
  },
  {
    path: "/question-analysis", // 试题解析
    name: "QuestionAnalysis",
    component: () => import("../views/Aio/QuestionAnalysis.vue"),
    meta: {
      title: "题目解析",
      showActionBar: false,
    },
  },
  {
    path: '/landing-page',
    name: 'LandingPage',
    component: () => import('../views/Aio/LandingPage.vue'),
    meta: {
      title: '好未来图书APP'
    }
  },
  {
    path: '/video-guide-pop',
    name: 'TaskGuidePop',
    component: () => import('../components/Aio/TaskGuidePop.vue'),
    meta: {
      title: 'TaskGuidePop'
    }
  },
  {
    path: '/sku-pop-mask',
    name: 'skuPopMask',
    component: () => import('../components/skuPopMask/Index.vue'),
    meta: {
      title: 'skuPopMask'
    }
  },{
    path: "/exercise-report",
    name: "ExerciseReport",
    component: () => import("../views/Aio/ExerciseReport.vue"),
    meta: {
      title: "",
      showActionBar: false,
    },
  },{
    path: "/star3-demo",
    name: "Star3Demo",
    component: () => import("../views/Aio/Star3Demo.vue"),
    meta: {
      title: "",
      showActionBar: false,
    },
  },{
    path: "/note-page-3star",
    name: "notePage",
    component:  NoteUploadPage,
    meta: {
      title: "",
      showActionBar: true,
    },
  },
  // 视频打点答题全屏幕互动 
  {
    path: "/task-dot", // 任务试卷
    name: "TaskDot",
    component: TaskDot,
    meta: {
      title: "答题",
      showActionBar: false,
    },
  },
  // 视频打点答题半屏互动
  {
    path: "/task-dot-half-screen", // 任务试卷
    name: "TaskDotHalfScreen",
    component: TaskDotHalfScreen,
    meta: {
      title: "答题",
      showActionBar: false,
    },
  },

];

export default aioRoutes;
